import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const RatecardTimelineModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=h17HuyQDK4g&ab_channel=apadua" />
);

export default RatecardTimelineModal;
